import React from 'react';
import { useUserStore } from '../../store/useUserStore';
import { Navigate } from '@tanstack/react-router';

interface ProfileGuardProps {
  children: React.ReactNode;
}

export const ProfileGuard: React.FC<ProfileGuardProps> = ({ children }) => {
  const { isAuthenticated } = useUserStore();

  if (!isAuthenticated) {
    const returnUrl =
      typeof window !== 'undefined'
        ? `${window.location.pathname}${window.location.search}${window.location.hash}`
        : '/';
    return <Navigate to="/sign-in" search={{ redirect: returnUrl }} />;
  }

  return <>{children}</>;
};
